import { Modal, Table } from "react-bootstrap";

const ModalDetails = ({ onClose, show, shipment }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="xl">
      <Modal.Header>
        <h4>جزئیات مرسوله</h4>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 overflow-x-auto px-2">
          <Table striped bordered={true} className="text-center">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شماره پارت</th>
                <th>ابعاد</th>
                <th>نوع بسته بندی</th>
                <th>محتویات</th>
                <th>وزن</th>
                <th>شکستنی</th>
                <th>مایعات</th>
              </tr>
            </thead>
            <tbody>
              {shipment?.internal_order.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.partnumber}</td>
                  <td>
                    <div className="flex ltr">
                      <span>{item.width}</span>
                      <span> × </span>
                      <span>{item.length}</span>
                      <span> × </span>
                      <span>{item.height}</span>
                    </div>
                  </td>
                  <td>{item.typeId}</td>
                  <td>{item.shipment}</td>
                  <td>{item.weight}</td>
                  <td>{item.isFragile ? "بله" : "خیر"}</td>
                  <td>{item.isLiquid ? "بله" : "خیر"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger" onClick={onClose}>
          خروج
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetails;
